import { render, staticRenderFns } from "./actionAgentCompany.vue?vue&type=template&id=6ebefe6a&"
import script from "./actionAgentCompany.vue?vue&type=script&lang=js&"
export * from "./actionAgentCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports